import React from 'react'
import { useForm } from 'react-hook-form';
import { callApi } from '../../ApiHelper/ApiHelper';
import { apiUrl } from '../../ApiHelper/ApiUrl';
import { toast } from 'react-toastify';
import BoxLoader from '../Loaders/BoxLoader';

export default function Newsletter() {
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        formState: { errors },
        reset,
        control
    } = useForm();
    const [loading, setLoading] = React.useState(false);

    const onSubmit = async (data) => {
        // console.log(data);
        const option = {
            method: 'POST',
            data: data,
        }
        try {
            setLoading(true);
            const res = await callApi(apiUrl.add_mail, option);
            if (res?.status === true) {
                setLoading(false);
                toast.success(res?.message);
                reset();
            } else {
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);
            // console.log(err);
        }
    }
    return (
        <section className="newsletter_section" >
            {/* <!-- container start --> */}
            <div div className="container pb-md-5 mb-5" >
                <div className="newsletter_box">
                    <div className="section_title" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="100">
                        {/* <!-- h2 --> */}
                        <h2>Subscribe newsletter</h2>
                        {/* <!-- p --> */}
                        <p>Be the first to recieve all latest post in your inbox</p>
                    </div>
                    <form onSubmit={handleSubmit(onSubmit)} data-aos="fade-in" data-aos-duration="1500" data-aos-delay="100">
                        <div className="form-group">
                            <input type="email" className="form-control" placeholder="Enter your email" {...register("mailId", {
                                required: "Company Name is required",
                            })} />
                        </div>
                        <div className="form-group">
                            <button className="btn" type='submit'>{loading ? <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div> : "SUBMIT"}</button>
                        </div>
                    </form>
                </div>
            </div >
        </section >
    )
}
